// PE serving-layer API — single entry point.
//
// THE ONE CHANGE: screens import `servingApi` from here and never touch the
// mock or live module directly. The live backend is the DEFAULT; mocks are an
// explicit opt-in so production can never silently regress to mocks:
//
//   VITE_SERVING_USE_MOCKS=true    → use mock.ts (local/dev only)
//   (unset / anything else)        → use live.ts (real backend URLs)
//
// No DB credentials and no server code live in this layer — frontend only.

import { liveServingApi } from "./live";
import { mockServingApi } from "./mock";
import type { ServingApi } from "./types";

const USE_MOCKS =
  (import.meta.env.VITE_SERVING_USE_MOCKS as string | undefined) === "true";

export const servingApi: ServingApi = USE_MOCKS ? mockServingApi : liveServingApi;
export const SERVING_USES_MOCKS = USE_MOCKS;

export * from "./types";
export { itemId, enforceTierComposition } from "./mock";
